export * from "./FavoritesManager";